// =====================================
//
//   儲值點數 相關功能 Service
//   Author: Gray
//   createtime: 2017 / 09 / 08
//   updatetime: 2017 / 09 / 08
//
// =====================================

window.InifECApp.factory("PointsStoreService", ['$q', '$http', function($q, $http) {

    var factory = {};

    // --------------------------------
    // 取得儲值點數面額
    // --------------------------------
    var getPointsStoreDenomination = function() {

       if(factory.cache["getPointsStoreDenomination"]) {
           return factory.cache["getPointsStoreDenomination"].promise;
       }

       factory.cache["getPointsStoreDenomination"] = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "GET",
            params: {
                op: "getPointsStoreDenomination"
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                factory.cache["getPointsStoreDenomination"].resolve(data);
            }
        }).error(function(data, status, headers, config) {
            factory.cache["getPointsStoreDenomination"].reject(data);
            console.error("[InifEC Error] : PointsStoreService.getPointsStoreDenomination request error.");
            console.error("status : " + status);
        });

        return factory.cache["getPointsStoreDenomination"].promise;
    }

    // --------------------------------
    // 建立點數儲值
    // --------------------------------
    var createPointsStore = function(totalamount, invoiceTitle, VATNumber, addressInfo, invoiceType, carrierType, loveCode, digitalCitizenCarrierID, mobilePhoneCarrierID, isDonate) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "POST",
            data: $.param({
                op: "createPointsStore",
                totalamount: totalamount,
                invoiceTitle: invoiceTitle,
                VATNumber: VATNumber,
                addressInfo: addressInfo,
                invoiceType: invoiceType,
                carrierType: carrierType,
                loveCode: loveCode,
                digitalCitizenCarrierID: digitalCitizenCarrierID,
                mobilePhoneCarrierID: mobilePhoneCarrierID,
                donate: isDonate,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsStoreService.createPointsStore request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得點數儲值資訊
    // --------------------------------
    var getPointsStore = function(pointsstoreid) {

       var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "GET",
            params: {
                op: "getPointsStore",
                pointsstoreid: pointsstoreid,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsStoreService.getPointsStore request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得使用者點數儲值列表
    // --------------------------------
    var getUserPointsStoreList = function(start, len, status, isMonthly) {

        var defer = $q.defer();

        if(status === undefined) {
            status = -1;
        }
        
        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "GET",
            params: {
                op: "getUserPointsStoreList",
                status: status,
                start: start,
                len: len,
                isMonthly: isMonthly,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsStoreService.getUserPointsStoreList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 設定付款方法
    // --------------------------------
    var setPayType = function(pointsstoreid, paymentmethod) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "POST",
            data: $.param({
                op: "setPayType",
                pointsstoreid: pointsstoreid,
                paymentmethod: paymentmethod,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsStoreService.setPayType request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 付款（信用卡／虛擬ＡＴＭ）
    // --------------------------------
    var payPointsStore = function(pointsstoreid, paymentmethod, totalamount) {

        var defer = $q.defer();
        var keynum = Math.floor((Math.random() * 3) + 1);

        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "POST",
            data: $.param({
                op: "payPointsStore",
                pointsstoreid: pointsstoreid,
                paymentmethod: paymentmethod,
                keynum: keynum,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {

                if (paymentmethod == Paytype_SinopacCreditCard) {
                    _payWithPaytype_SinopacCreditCard(pointsstoreid, paymentmethod, totalamount, data, keynum, defer);
                } else {
                    defer.resolve(data);
                }
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsStoreService.payPointsStore request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // [private] 信用卡付款（踢至銀行付款頁）
    // ------------------------------
    var _payWithPaytype_SinopacCreditCard = function(pointsstoreid, paymentmethod, totalamount, data, keynum, defer) {

        // app 付款
        if(window.location.protocol == "file:") {
            var form = {
                method: "POST",
                action: PAYMENT_URL,
                ShopNO: SINOPAC_ShopNO,
                KeyNum: keynum,
                OrderNO: pointsstoreid+'-'+paymentmethod+'-'+0,
                Amount: totalamount * 100,
                CurrencyID: "NTD",
                PrdtName: "inif印衣服",
                AutoBilling: "Y",
                Digest: data.gatewayRstJSON,
                Param1: "payFromApp", // 此flag讓永豐回傳可以踢到app要的回傳頁面
            }

            var msg = {
                type: 'payByCreditCard',
                form: form
            }

            msg = JSON.stringify(msg);

            // post msg to app
            if( window.WebViewBridge !== undefined && window.WebViewBridge.postMessage){
                window.WebViewBridge.postMessage(msg);
            } else if( window.WebViewBridge !== undefined && window.WebViewBridge.send){
                window.WebViewBridge.send(msg);
            }
        } else {
            var form = document.createElement("form");

            form.method = "POST";
            form.action = PAYMENT_URL;  

            var ShopNO = document.createElement("input"); 
            //ShopNO改取 SinopacContext.ShopNO 的值
            ShopNO.value= SINOPAC_ShopNO;
            ShopNO.name= "ShopNO";
            form.appendChild(ShopNO);  
            var KeyNum = document.createElement("input"); 
            //keyNum 直改random (1-3),與此次金鑰使用KeyNum 相同
            KeyNum.value= keynum;
            KeyNum.name= "KeyNum";
            form.appendChild(KeyNum);
            var OrderNO = document.createElement("input"); 
            OrderNO.value= pointsstoreid+'-'+paymentmethod+'-'+0;
            OrderNO.name= "OrderNO";
            form.appendChild(OrderNO);
            var Amount = document.createElement("input"); 
            // 金額要 *100 傳出
            Amount.value= totalamount * 100;
            Amount.name= "Amount";
            form.appendChild(Amount);
            var CurrencyID = document.createElement("input"); 
            CurrencyID.value= "NTD";
            CurrencyID.name= "CurrencyID";
            form.appendChild(CurrencyID);
            var PrdtName = document.createElement("input"); 
            PrdtName.value= "inif印衣服";
            PrdtName.name= "PrdtName";
            form.appendChild(PrdtName);
            var AutoBilling = document.createElement("input"); 
            AutoBilling.value= "Y";
            AutoBilling.name= "AutoBilling";
            form.appendChild(AutoBilling);
            var Digest = document.createElement("input"); 
            Digest.value= data.gatewayRstJSON;
            Digest.name= "Digest";
            form.appendChild(Digest);

            document.body.appendChild(form);
            form.submit();
        }

        defer.resolve(data);
    }

    // --------------------------------
    // 付款（臨櫃匯款）
    // --------------------------------
    var payPointsStoreWithOutwardRemittance = function(pointsstoreid, remittanceName, remittanceCode, remittancePhone, remittanceDate) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "POST",
            data: $.param({
                op: "payPointsStoreWithOutwardRemittance",
                pointsstoreid: pointsstoreid,
                remittanceName: remittanceName,
                remittanceCode: remittanceCode,
                remittancePhone: remittancePhone,
                remittanceDate: remittanceDate,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsStoreService.payPointsStoreWithOutwardRemittance request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 作廢該次交易
    // --------------------------------
    var discardPointsStore = function(pointsstoreid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "POST",
            data: $.param({
                op: "discardPointsStore",
                pointsstoreid: pointsstoreid,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsStoreService.discardPointsStore request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得使用者點數儲值以及交易列表
    // --------------------------------
    var getUserPointsStoreCombineList = function(start, len) {

       var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/PointsStoreAction.do",
            method: "GET",
            params: {
                op: "getUserPointsStoreCombineList",
                start: start,
                len: len,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : PointsStoreService.getUserPointsStoreCombineList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    /*==========================
        Members
    ==========================*/
    factory.cache = {};

    /*==========================
        Methods
    ==========================*/
    factory.getPointsStoreDenomination = getPointsStoreDenomination; // 取得儲值點數面額
    factory.createPointsStore = createPointsStore; // 建立點數儲值
    factory.getPointsStore = getPointsStore; // 取得點數儲值資訊
    factory.getUserPointsStoreList = getUserPointsStoreList; // 取得使用者點數儲值列表
    factory.setPayType = setPayType; // 設定付款方法
    factory.payPointsStore = payPointsStore; // 付款（信用卡／虛擬ＡＴＭ）
    factory.payPointsStoreWithOutwardRemittance = payPointsStoreWithOutwardRemittance; // 付款（臨櫃匯款）
    factory.discardPointsStore = discardPointsStore; // 作廢該次交易
    factory.getUserPointsStoreCombineList = getUserPointsStoreCombineList; // 取得使用者點數儲值以及交易列表

    return factory;
}]);